export class MerchantInFoModel {
  merchantId!: number;
  merchantName!: string;
  merchantNameEng!: string;
  merchantNameTh!: string;
  merchantBranchCode!: string;
  isSample!: boolean;
  merchantTaxId!: string;
}
